import { Image, Text, View } from "@react-pdf/renderer";
import { styles } from "./styles/styles";
import { PrintListItem } from "../RecipeSingleView/PDFDownloadButton/PDFDownloadButton";

interface RecipePdfTimeAndPortionIcon {
  src: string;
  text: string;
}

export interface RecipePdfTimeAndPortionIcons {
  completeTime: RecipePdfTimeAndPortionIcon;
  prepareTime: RecipePdfTimeAndPortionIcon;
  bakingTime: RecipePdfTimeAndPortionIcon;
  cookingTime: RecipePdfTimeAndPortionIcon;
  coolingTime: RecipePdfTimeAndPortionIcon;
  restingTime: RecipePdfTimeAndPortionIcon;
  freezingTime: RecipePdfTimeAndPortionIcon;
  oberunterHitze: RecipePdfTimeAndPortionIcon;
  umluftIcon: RecipePdfTimeAndPortionIcon;
}

export const RecipePdfTimeAndPortion = ({
  recipe,
  icons,
}: {
  recipe: PrintListItem;
  icons: RecipePdfTimeAndPortionIcons;
}) => {
  // const totalTime = recipe.item.zubereitungszeit;
  const {
    zeit_backen,
    zeit_kochen,
    zeit_kuehlen,
    zeit_ruhen,
    zeit_tiefkuehlen,
    zubereitungszeit,
    umluft,
  } = recipe.item;
  const totalTime =
    zubereitungszeit -
    (zeit_kochen + zeit_backen + zeit_kuehlen + zeit_ruhen + zeit_tiefkuehlen);
  const {
    bakingTime,
    completeTime,
    prepareTime,
    cookingTime,
    coolingTime,
    restingTime,
    freezingTime,
    oberunterHitze,
    umluftIcon,
  } = icons;
  const convertedImageUrl = (url: string) =>
    `/api/convert-svg?url=${encodeURIComponent(url)}`;
  const RowElement = ({
    element,
    time,
  }: {
    element: { src: string; text: string };
    time?: number;
  }) => {
    return (
      <View style={styles.row}>
        {/* @react-pdf/renderer Image does not need alt text */}
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <Image
          src={convertedImageUrl(element.src)}
          style={styles.prepTimeIcon}
        />
        <Text style={styles.textRegular}>{element.text} </Text>
        {time && <Text style={styles.textBold}>{time} Min.</Text>}
      </View>
    );
  };
  return (
    <View style={styles.preparation}>
      <RowElement element={completeTime} time={totalTime} />
      {zeit_kochen && <RowElement element={cookingTime} time={zeit_kochen} />}
      {zubereitungszeit && (
        <RowElement element={prepareTime} time={zubereitungszeit} />
      )}
      {zeit_backen && (
        <>
          <RowElement element={bakingTime} time={zeit_backen} />
          {umluft ? (
            <RowElement element={umluftIcon} />
          ) : (
            <RowElement element={oberunterHitze} />
          )}
        </>
      )}

      {zeit_kuehlen && <RowElement element={coolingTime} time={zeit_kuehlen} />}
      {zeit_ruhen && <RowElement element={restingTime} time={zeit_ruhen} />}
      {zeit_tiefkuehlen && (
        <RowElement element={freezingTime} time={zeit_tiefkuehlen} />
      )}
    </View>
  );
};
